import React, { useContext, memo, useState } from "react";

import { validators } from "components/Form/validators";
import { FailContext } from "components/Form";
import Text from "components/Text";

import { EnumCategories } from "models/Ticket";
import { ISelect, IOption } from "./interface";
import { SelectGlobal } from "./styles";

const Select: React.FC<ISelect> = (props) => {
  const {
    name,
    value,
    options,
    required,
    category,
    stateName,
    customClassName,
    subjection,
    width = 'auto',
    skipSelectOption,
    isFilterProtocols,
    ...rest
  } = props;
  const fail = useContext(FailContext);
  const [isRotateIcon, setIsRotateIcon] = useState<boolean>(false);
  
  const isValid = () => {
    if (validators.select) {
      return validators.select(value, name, required);
    }
    return true;
  };

  const shouldRenderOption = (option: IOption, index: number) => {
    if (option?.show?.length && subjection) {
      if (option?.show?.includes(subjection)) {
        return (
          <option id={`select-option-${option.value}`} key={index} value={option.value} disabled={option.disabled}>
            {option.label}
          </option>
        );
      }
      return null;
    }

    if (category !== EnumCategories.RECLAMACAO_TECNICA && category !== EnumCategories.COMERCIAL) {
      if (!option?.show?.includes("19")) {
        return (
          <option id={`select-option-${option.value}`} key={index} value={option.value} disabled={option.disabled}>
            {option.label}
          </option>
        );
      }
    }
  };

  return (
    <SelectGlobal
      onClick={() => setIsRotateIcon(!isRotateIcon)} 
      onBlur={() => setIsRotateIcon(false)}
      isRotateIcon={isRotateIcon}
      className={`flex-1 relative ${customClassName}`}
    >
      <select
        {...rest}
        name={name}
        value={value}
        data-customtype="select"
        required={required || false}
        data-statename={stateName || undefined}
        style={isValid() && fail ? { border: "2px solid tomato", width: width } : { width: width }}
      >
        {
          isFilterProtocols ?
            (<option value="">
              SELECIONE
            </option>)
            : !skipSelectOption && (
              <option value="" disabled>
                SELECIONE
              </option>
            )
        }
        {options?.map((option, _) => shouldRenderOption(option, _))}
      </select>
      {isValid() && fail && (
        <Text size={12} className="animated fadeIn mt-1 color-danger position-alert">
          {isValid()}
        </Text>
      )}
    </SelectGlobal>
  );
};

export default memo(Select);
